import { z } from 'zod';
/**
 * Project-Assistant "Cockpit" (Plan §18 / Paket D, Issue #65).
 *
 * Strukturierte Übersicht über den Projekt-Zustand in 4 Spalten:
 *  - Stand     -> aktueller Status, Vollständigkeit, Lead, Frist
 *  - Nächstes  -> konkrete Next-Action-Items aus dem Datensatz abgeleitet
 *  - Kritisch  -> Warnings (Frist nah, Genehmigung lange offen, Pflichtfelder leer)
 *  - Wartend   -> Blocker (auf Freigabe wartend, ungelöste Inputs etc.)
 *
 * Berechnung läuft heuristisch im Backend — kein LLM. Der Endpoint liefert die
 * vollen, lokalisierten Strings — das Frontend rendert nur, ohne weitere
 * Domänenlogik.
 */
export const cockpitSeverity = z.enum(['info', 'warn', 'danger', 'success']);
export const cockpitItem = z.object({
    /** lucide-react Icon-Name (z. B. 'Clock', 'AlertTriangle'). */
    icon: z.string().min(1),
    /** Kurzes Label, immer Pflicht. */
    label: z.string().min(1),
    /** Optionale 2. Zeile mit Detail/Begründung. */
    detail: z.string().optional(),
    severity: cockpitSeverity.optional(),
    /** Optionale interne Route (z. B. '/projects/123#kommentare'). */
    link: z.string().optional(),
});
export const cockpitResponse = z.object({
    projectId: z.number().int().positive(),
    stand: z.array(cockpitItem),
    next: z.array(cockpitItem),
    critical: z.array(cockpitItem),
    waiting: z.array(cockpitItem),
    generatedAt: z.string().datetime(),
});
